import styled from "styled-components";
import {
  fontWeightBold,
  h3Regular,
} from "../../../../components/typography/MuiTypography.style";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const TooltipAddIconWrapper = styled.div`
  padding-top: 16px;
  .add-icon {
    margin-right: 6px;
  }
  .btn-tertiary {
    height: auto;
  }
`;

export const BillingConfigurationWrapper = styled.div`
  padding-top: 24px;

  .header {
    padding: 0px 16px;
  }
  .semi-header {
    justify-items: right;
    padding: 8px 28px 8px 0px;
  }

  .header-right {
    align-items: center;
    display: flex;
    justify-content: flex-end;

    .MuiButton-root {
      height: auto;
      padding-left: 4px;

      svg {
        margin-right: 10px;
      }
    }
  }

  .header-left {
    line-height: 20px;
    color: ${COLORS.cirrus_black10};
  }

  .title-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .accordion-header {
    margin-top: 24px !important;
    ${responsive.MOBILE`
        margin-top: 16px !important;
    `}
  }

  .add-icon {
    margin-right: 6px;
  }

  .special-billing-instruction {
    width: 100%;
    padding: 40px 0px 0px 0px;
    background-color: ${COLORS.cirrus_black1};

    ${responsive.MOBILE`
        padding: 16px 0px !important;
    `}

    ${responsive.TABLET_PORTRAIT`
        padding: 24px 0px;
      `}
  }
  .main-container {
    width: 100%;
    padding: 24px 16px;
    background-color: ${COLORS.cirrus_black1};
    border-bottom: 1px dashed ${COLORS.primary_light_blue};

    ${responsive.MOBILE`
        padding: 16px 8px !important;
    `}

    ${responsive.TABLET_PORTRAIT`
        padding: 24px 8px;
      `}

    > .MuiGrid-item {
      ${responsive.MOBILE`
      padding-left: 2px !important;
      padding-right: 2px !important;
    `}
    }
  }

  .header-grid {
    display: flex;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .form-field {
    &:nth-child(-n + 3) {
      margin-top: 0px;
    }
    &:nth-child(n + 4) {
      margin-top: 40px;
      ${responsive.TABLET_LANDSCAPE`
         margin-top: 0;
      `}
    }
    &.inner {
      margin-top: 24px;
    }

    ${responsive.TABLET_PORTRAIT`
      &:nth-child(1), &:nth-child(2) {
        margin-top: 0px;
      }
      &:nth-child(n+3) {
        margin-top: 40px;
      }
    `}

    ${responsive.MOBILE`
      &:nth-child(1) {
        margin-top: 0px;
      }
      &:nth-child(n+2) {
        margin-top: 16px;
      }
    `}
  }
  .select-preferences-header {
    padding: 32px 0 16px 0;
  }
  .special-billing-instruction {
    .notes-input {
      .MuiInputBase-root {
        padding: 0px;
      }
    }
  }

  .opportunity-id-container {
    position: relative;
  }

  .validate-link {
    ${h3Regular}
    ${fontWeightBold}
        position: absolute;
    top: 0px;
    text-decoration: underline;
    text-underline-offset: 4px;
    right: 0px;
    color: ${COLORS.primary_light_blue};
  }
`;
